import { render } from "./Maintenance.vue?vue&type=template&id=2594d70a&scoped=true"
const script = {}

import "./Maintenance.vue?vue&type=style&index=0&id=2594d70a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2594d70a"]])

export default __exports__